/**
 * Size chart popup (replaces the Kiwi Size Chart app). Markup and charts: snippets/size-chart.liquid.
 * Measurements are stored in inches (data-in); centimetres are calculated. The unit the customer
 * picks is remembered for the next products.
 */
class SizeChart extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.dialog = this.querySelector('dialog');

    this.querySelector('.size-chart__open').addEventListener('click', () => this.open());
    this.querySelector('.size-chart__close').addEventListener('click', () => this.dialog.close());
    // Click on the dark background closes the popup.
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.querySelectorAll('[data-unit-button]').forEach((button) =>
      button.addEventListener('click', () => this.setUnit(button.dataset.unitButton, true)),
    );

    let unit = this.dataset.defaultUnit || 'cm';
    try {
      unit = localStorage.getItem('size-chart-unit') || unit;
    } catch (error) {
      // Storage blocked: keep the default unit.
    }
    this.setUnit(unit, false);
  }

  open() {
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  setUnit(unit, remember) {
    const factor = unit === 'cm' ? 2.54 : 1;
    this.querySelectorAll('td[data-in]').forEach((cell) => {
      const inches = parseFloat(cell.dataset.in);
      if (Number.isNaN(inches)) return;
      cell.textContent = String(Math.round(inches * factor * 10) / 10);
    });
    this.querySelectorAll('[data-unit-button]').forEach((button) =>
      button.setAttribute('aria-pressed', String(button.dataset.unitButton === unit)),
    );
    if (!remember) return;
    try {
      localStorage.setItem('size-chart-unit', unit);
    } catch (error) {
      // Storage blocked: the choice only lasts for this page.
    }
  }
}

if (!customElements.get('size-chart')) customElements.define('size-chart', SizeChart);
